import { DefaultAppState } from '../models/redux/DefaultAppState';
import { DefaultAuthState } from '../models/redux/DefaultAuthState';
import { DefaultCustomerState } from '../models/redux/DefaultCustomerState';
import { DefaultRouteState } from '../models/redux/DefaultRouteState';
import { AppReducer } from './App/reducer';
import { AuthReducer } from './Auth/reducer';
import { CustomerReducer } from './Customer/reducer';
import { RouteReducer } from './Route/reducer';
import { TableReducer, TableState } from './Table/reducer';

export interface AppState {
  table: TableState;
  auth: DefaultAuthState;
  app: DefaultAppState;
  customer: DefaultCustomerState;
  routes: DefaultRouteState;
}

export const reducers = {
  table: TableReducer,
  auth: AuthReducer,
  app: AppReducer,
  customer: CustomerReducer,
  routes: RouteReducer
};
